var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgComboShipment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "5 5 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.25 25C5.559 25 5 24.441 5 23.75V12.5c0-.691.559-1.25 1.25-1.25H17.5c.691 0 1.25.559 1.25 1.25v11.25c0 .691-.559 1.25-1.25 1.25zM20 8.75h-8.75v-2.5c0-.691.559-1.25 1.25-1.25h11.25c.691 0 1.25.559 1.25 1.25V17.5c0 .691-.559 1.25-1.25 1.25h-2.5V10c0-.69-.559-1.25-1.25-1.25"
})));
export default SvgComboShipment;